import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Microsoft16 = ({
  height = 16,
  width = 16,
  color = colors.black,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="-1 -1 16 16" {...props}>
    <path
      d="M5.89167 0.875H1.10833C0.979467 0.875 0.875 0.979467 0.875 1.10833V5.89167C0.875 6.02053 0.979467 6.125 1.10833 6.125H5.89167C6.02053 6.125 6.125 6.02053 6.125 5.89167V1.10833C6.125 0.979467 6.02053 0.875 5.89167 0.875Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8917 0.875H8.10833C7.97947 0.875 7.875 0.979467 7.875 1.10833V5.89167C7.875 6.02053 7.97947 6.125 8.10833 6.125H12.8917C13.0205 6.125 13.125 6.02053 13.125 5.89167V1.10833C13.125 0.979467 13.0205 0.875 12.8917 0.875Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.89167 7.875H1.10833C0.979467 7.875 0.875 7.97947 0.875 8.10833V12.8917C0.875 13.0205 0.979467 13.125 1.10833 13.125H5.89167C6.02053 13.125 6.125 13.0205 6.125 12.8917V8.10833C6.125 7.97947 6.02053 7.875 5.89167 7.875Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8917 7.875H8.10833C7.97947 7.875 7.875 7.97947 7.875 8.10833V12.8917C7.875 13.0205 7.97947 13.125 8.10833 13.125H12.8917C13.0205 13.125 13.125 13.0205 13.125 12.8917V8.10833C13.125 7.97947 13.0205 7.875 12.8917 7.875Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
